<template lang="html">
  <canvas ref="canvas" :width="width" :height="height" />
</template>

<script>
import ChartMixin from './ChartMixin'

export default {
  mixins: [
    ChartMixin
  ],
  computed: {
    options () {
      return {
        type: 'pie'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
